export default __webpack_public_path__ + "static/media/fail-concierge.ed32838d.png";